import { paths } from "~/router/paths";

// Pages for logged-out users. An expired session must not sign anyone out
// here; every other page sends the user to log in.
export const guestPaths: string[] = [
  paths.auth.store_login,
  paths.auth.login,
  paths.auth.register,
  paths.auth.forgot,
];

// Pages that hide the upsell banner and upgrade button. Checkout and settings
// need a logged-in account, so they are not guest pages.
export const excludePaths: string[] = [
  ...guestPaths,
  paths.checkout.index.replace(":id", ""),
  paths.settings.index,
];
